// This version goes to the next page as soon as a succesful password is submitted

import React, { useState } from 'react';
import { usePageControl } from '../context/PageControlContext';

// SHA-256 hashing utility
async function hashText(text) {
  const encoder = new TextEncoder();
  const data = encoder.encode(text);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(hashBuffer))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

const GuessPassword = ({ hashedAnswer, onSuccess, children }) => {
  const [userInput, setUserInput] = useState('');
  const [feedback, setFeedback] = useState('');

  // Navigation
  const { goNext } = usePageControl();

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Normalize to lowercase for case-insensitive match
    const normalizedInput = userInput.trim().toLowerCase();
    const userHash = await hashText(normalizedInput);

    if (userHash === hashedAnswer) {
      setFeedback('correct');
      onSuccess?.();

      // Automatically move to next page
      goNext();

    } else {
      setFeedback('incorrect');
    }
  };

  const handleClear = () => {
    setUserInput('');
    setFeedback('');
  };

  return (
    <div className="guess-password">
      <form onSubmit={handleSubmit}>
        <label>
          {children || <p>Enter:</p>}
          <input
            type="text"
            autocomplete="off"
            value={userInput}
            onChange={(e) => setUserInput(e.target.value)}
          />
        </label>
        <div className="mt-2 text-center">
          <button
            type="button"
            onClick={handleClear}
            className="btn btn-outline"
            style={{ marginLeft: '8px' }}
          >
            Clear errors
          </button>
          <button type="submit" className="btn">Submit</button>
        </div>
      </form>

      {feedback === 'incorrect' && (
        <div className="validation-alert validation-error">
          Incorrect! Clear errors and try again.
        </div>
      )}
    </div>
  );
};

export default GuessPassword;
